import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { Shift } from 'modules/shift_management/lib/types'

export interface Props {
  shift: Shift
  templateTitle: string
}

const ShiftTitle = ({ shift, templateTitle }: Props) => {
  const color = shift.isBackup ? 'grey600' : 'grey1000'

  return (
    // TODO: Adjust this when templateTitle (template + template week) is also part of name
    <Text.Normal size="100" weight="bold" color={color} ellipsis>
      {shift.name || templateTitle}
    </Text.Normal>
  )
}

export default observer(ShiftTitle)
